<template>
  <v-flex xs12 class="customer-dashboard-container">
    <v-layout wrap row>
      <v-flex xs12>
        <occupancy-statistic/>
      </v-flex>
      <v-flex xs12 class="text-left">
        <booking-statistic/>
      </v-flex>
    </v-layout>
  </v-flex>
</template>

<script>
  import OccupancyStatistic from '../statistics/OccupancyStatistics';
  import BookingStatistic from '../statistics/BookingStatistics';

  export default {
    name: 'CustomerDashboard',
    components: {
      OccupancyStatistic, BookingStatistic
    },
    data() {
      return {};
    },
    mounted() {},
    methods: {}
  };
</script>

<style lang="scss">
  .customer-dashboard-container {
    height: 100%;
  }
</style>
